import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import ActiviteitenPartners from "../components/ActiviteitenPartners";
import { IMAGES } from "../data/site";

const features = [
  { title: "Beachsport", text: "Diverse sporten op het zand voor jong en oud." },
  { title: "Teamactiviteiten", text: "Spelvormen die samenwerking en plezier combineren." },
  { title: "Initiaties", text: "Probeer iets nieuws onder begeleiding van trainers." },
  { title: "Tornooien", text: "Vriendschappelijke wedstrijden in zomerse sfeer." },
];

const gallery = [
  IMAGES.sportstrandGal1,
  IMAGES.sportstrandGal2,
  IMAGES.sportstrandGal3,
];

export default function Sportstrand() {
  return (
    <>
      <Seo
        title="Sportstrand | Mechelen Beach 2026"
        description="Ontdek de sportieve activiteiten van Mechelen Beach 2026 in een zomerse setting."
      />

      <PageHero
        eyebrow="Sportstrand"
        title="Bewegen, spelen en plezier maken op het zand"
        subtitle="Voor wie graag beweegt en geniet van sportieve sfeer is het Sportstrand de ideale plek. Roundnet, frisbee, capoeira en zoveel meer — onder begeleiding van Mechelse sportverenigingen."
        image={IMAGES.sportstrandMain}
        imageAlt="Sportieve activiteit op Mechelen Beach"
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        secondaryCta={{ label: "Volleybal", to: "/volleybal" }}
      />

      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="photo">
              <img src={IMAGES.sportstrandWide} alt="Sport op het zand" className="w-full h-[360px] sm:h-[460px] object-cover" />
            </div>
            <div>
              <span className="eyebrow">Wat te beleven</span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
                Energie van zonsopgang tot zonsondergang
              </h2>
              <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
                Verschillende Mechelse sportverenigingen zorgen voor gratis
                initiaties. Daarnaast kan je sportmateriaal uitlenen — ballen,
                spikeball-sets en Kubb-spelen.
              </p>
              <div className="mt-8 grid grid-cols-2 gap-4">
                {features.map((f, i) => (
                  <div
                    key={f.title}
                    data-testid={`sportstrand-activity-${i}`}
                    className="bg-white rounded-xl border border-[#ebd9b5] p-4"
                  >
                    <p className="font-display font-semibold text-[#2b1c10]">{f.title}</p>
                    <p className="mt-1 text-xs text-[#6b5945] leading-relaxed">{f.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-sand-2 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Sfeerbeelden</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Sport in beeld
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
            {gallery.map((src, i) => (
              <div key={i} data-testid={`sportstrand-gallery-${i}`} className="overflow-hidden rounded-xl aspect-square group">
                <img
                  src={src}
                  alt={`Sportstrand sfeer ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <ActiviteitenPartners
        text="Deze partners zorgen mee voor sport, initiaties en beweging op het sportstrand van Mechelen Beach."
      />

      <CtaBanner
        title="Sportief de zomer in?"
        text="Bekijk het volledige programma van Mechelen Beach 2026."
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        image={IMAGES.sportstrandMain}
      />
    </>
  );
}
